// @flow
/* eslint-env browser */

import '@webcomponents/custom-elements';

import debug from '../../shared/debug';

import { CoreService, isInViewport, loadScript, applyWideAdWorkaround } from './lib';

applyWideAdWorkaround();

window.ARK_GPT_DEFERRED = window.ARK_GPT_DEFERRED || loadScript('https://cx.unva.net/js/display.js');
window.cxua = window.cxua || { cmd: [] };
const REFRESH_TIME = 60000;

export class DisplayAdComponent extends HTMLElement {
    log = debug('arkadium-ads:display:component');

    refreshInterval: any;

    gtag: any;

    slot: any;

    size: number[][];

    targeting: any[];

    id: string;

    adId: string;

    partnerId: string;

    _isRendered: boolean = false;

    _isDisconnected: boolean = true;

    defaultTargeting = [
        // ['gdpr_consent', localStorage.getItem('ark-user-agree-cookies-AdsGdpr')],
    ];

    slotMapping = {
        ark_display_r1: { id: '/2/i/2' },
        ark_display_r2: { id: '/2/i/3' },
        ark_display_r3: { id: '/2/i/4' },
        ark_display_t1: { id: '/2/i/1' },
        ark_display_b1: { id: '/2/i/5' },
    };

    coreService: CoreService;

    constructor() {
        super();
        this.coreService = CoreService.getInstance();
    }

    connectedCallback() {
        this.log('connectedCallback started');
        this._isDisconnected = false;
        this.size = this.getSize();
        this.adId = this.dataset.id.replace(/_/g, '_');
        this.partnerId = this.dynamicMapping();
        window.cxua.cmd.push(() => {
            this.innerHTML = `<div id='${this.adId}'></div>`;
            this.refreshInterval = setInterval(() => this._refresh(), REFRESH_TIME);
            this.coreService.queue(this);
            this.log('connectedCallback finished');
        });
    }

    render() {
        this.log(`render started: ${this.adId}`);
        if (this._isRendered) {
            this.log(`rendered already: ${this.adId}`);
            return;
        }
        this._isRendered = true;
        window.cxua.cmd.push(() => {
            this.slot = window.cxua.defineSlot(this.partnerId, this.size, this.adId).addService(window.cxua.pubads());
            window.cxua.display(this.adId);
        });
        this.log(`render done: ${this.adId}`);
    }

    isViewable() {
        return isInViewport(this);
    }

    isRendered() {
        return this._isRendered;
    }

    _refresh() {
        this.log(`refresh started: ${this.adId}`);
        if (this.isViewable() && !this._isDisconnected) {
            this.log(`refresh available: ${this.adId}`);
            window.cxua.display(this.adId);
            this.coreService.onShowGTMEvent([this.adId], true);
        }
        this.log(`refresh done: ${this.adId}`);
    }

    refresh() {
        // Arena can't refresh this ad
    }

    getSize() {
        const size = this.getAttribute('dimensions');
        if (!size) {
            this.log('getSize: "dimensions" is not specified');
            return [];
        }
        try {
            return JSON.parse(size);
        } catch (e) {
            this.log(e);
            return [];
        }
    }

    dynamicMapping() {
        const slot = this.slotMapping[this.adId];
        if (slot) {
            return slot.id;
        }
        if (this.size[0] && this.size[0][0] === 728) {
            return '/2/i/1';
        }
        return '/2/i/2';
    }

    disconnectedCallback() {
        this._isDisconnected = true;
        this.coreService.dequeue(this);
        clearInterval(this.refreshInterval);
    }
}
